import axios from "axios";
import React, { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Collapse,
  Container,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneIcon from "@mui/icons-material/Done";
import Alert from "@mui/material/Alert";

/**
 * я вписав весь код в один файл, щоб не розмазувати цей функціонал по проекту.
 * якщо фіча буде мати розвиток - todo: refactor this:)
 */

export function EmailChip(props) {
  const { email, size } = props;
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setIsCopied(true);
  };

  return (
    <Tooltip
      PopperProps={{
        disablePortal: true,
      }}
      title="Copied"
      placement="right"
      open={isCopied}
      disableFocusListener
      disableHoverListener
      disableTouchListener
    >
      <Chip
        label={email}
        size={size}
        clickable
        onClick={handleCopy}
        onMouseLeave={() => {
          setIsCopied(false);
        }}
        icon={isCopied ? <DoneIcon /> : <ContentCopyIcon />}
      />
    </Tooltip>
  );
}

export default function AsanaTimeTrackingPage() {
  const [spreadsheetUrl, setSpreadsheetUrl] = useState("");
  const [asanaUser, setAsanaUser] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({
    display: false,
    severity: "error",
    message: "",
  });

  const hideAlert = () =>
    setAlert((a) => ({
      ...a,
      display: false,
    }));

  /**
   * @param {string} url
   * @returns {string}
   * @throws {Error}
   */
  const extractSpreadsheetIdFromUrl = (url) => {
    const re =
      /(https?:\/\/)?docs\.google\.com\/spreadsheets\/d\/([^/]+)(\/.*)?/i;
    if (!re.test(url)) {
      throw new Error("Invalid Google Spreadsheet URL format");
    }
    return url.replace(re, "$2");
  };

  const waitExport = async (spreadsheetId) => {
    const timeout = (delay) =>
      new Promise((resolve) => setTimeout(resolve, delay));

    while (true) {
      await timeout(1000 * 10);

      try {
        const response = await axios.get(
          `/api/v1/asana-time-tracking/export/${spreadsheetId}`,
        );

        if (response.data["status"] === "failed") {
          throw new Error(response.data["message"]);
        }
        if (response.data["status"] !== "processing") {
          break;
        }
      } catch (e) {
        if (e.response && e.response.status === 404) {
          continue;
        }
        throw e;
      }
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    try {
      if (!spreadsheetUrl.length || !asanaUser.length) {
        throw new Error("Invalid form data");
      }

      const spreadsheetId = extractSpreadsheetIdFromUrl(spreadsheetUrl);

      hideAlert();
      setIsLoading(true);

      await axios.post("/api/v1/asana-time-tracking/export", {
        google_spreadsheet_id: spreadsheetId,
        asana_user: asanaUser,
      });
      await waitExport(spreadsheetId);

      setAlert({
        display: true,
        severity: "success",
        message: "Time tracking exported",
      });
    } catch (e) {
      setAlert({
        display: true,
        severity: "error",
        message: e.response ? e.response.data.message : e.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="asana-time-tracking-page">
      <Container>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={handleFormSubmit}
        >
          <Collapse in={alert.display}>
            <Alert
              severity={alert.severity}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={hideAlert}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              {alert.message}
            </Alert>
          </Collapse>
          <TextField
            label="Google Spreadsheet URL"
            variant="outlined"
            required
            fullWidth
            margin="normal"
            value={spreadsheetUrl}
            onChange={(e) => {
              setSpreadsheetUrl(e.target.value);
            }}
            disabled={isLoading}
          />
          <TextField
            label="User email/asanaId"
            variant="outlined"
            required
            fullWidth
            margin="normal"
            value={asanaUser}
            onChange={(e) => {
              setAsanaUser(e.target.value);
            }}
            disabled={isLoading}
          />
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {isLoading && <CircularProgress sx={{ mr: 1 }} />}
            <Button
              size="medium"
              variant="contained"
              endIcon={<ImportExportIcon />}
              disabled={isLoading}
              type="submit"
            >
              Export
            </Button>
          </Box>
        </Box>
        <Box sx={{ mt: 3 }}>
          <div variant="body2" display="block" gutterBottom>
            Before exporting, share the Google Document with the user{" "}
            <EmailChip
              email="energame-bad-main@energame-bad-services.iam.gserviceaccount.com"
              size="small"
            />
            , and grant the "Editor" role.
          </div>
          <Typography variant="body2" display="block" gutterBottom>
            Data will be inserted in the last sheet in document.
          </Typography>
        </Box>
      </Container>
    </div>
  );
}
